import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Tooltip } from '@mui/material';
import i18 from 'i18next';
import { Typography } from '@totalsoft/rocket-ui';
import { ParentCommentWrapper } from './CommentsStyles';

function ParentCommentComponent({ comment }) {
  return (
    <ParentCommentWrapper container>
      <Grid item container gap={1}>
        <Tooltip title={comment.userName}>
          <Grid item>
            <Typography fontWeight='bold'>{comment.userName}</Typography>
          </Grid>
        </Tooltip>
        <Grid item>
          <Typography color='grey'>
            {new Date(comment.date).toLocaleTimeString(i18.language, { hour: '2-digit', minute: '2-digit' })}
          </Typography>
        </Grid>
      </Grid>
      <Grid item xs>
        <Typography whiteSpace='break-spaces' color='grey'>
          {comment.commentText}
        </Typography>
      </Grid>
    </ParentCommentWrapper>
  );
}

ParentCommentComponent.propTypes = {
  comment: PropTypes.object.isRequired
};

export default ParentCommentComponent;
